import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import CallIcon from '@material-ui/icons/Call';
import { makeStyles } from '@material-ui/core/styles';
import WAIcon from '@material-ui/icons/WhatsApp'
import EmailIcon from '@material-ui/icons/Email'
import IGIcon from '@material-ui/icons/Instagram'
import FBIcon from '@material-ui/icons/Facebook'

const useStyles = makeStyles((theme) => ({
    container: {
        background: 'linear-gradient(135deg, #091826 0%, #102f4a 100%)',
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(2),
        padding: theme.spacing(4),
        borderRadius: 32,
        color: '#fff',
        boxShadow: '0 20px 45px rgba(0,0,0,0.4)',
    },
    link: {
        color: '#fff',
        fontWeight: 600,
        textDecoration: 'none',
        paddingRight: 0,
        '&:hover': {
            textDecoration: 'underline',
        }
    },
    gridTitle: {
        color: theme.palette.secondary.light,
        fontWeight: 700,
        letterSpacing: '.08em',
    },
    list: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
    },
    listItem: {
        marginBottom: theme.spacing(1),
    },
    address: {
        color: '#d0d7e3',
        marginBottom: theme.spacing(2),
    },
    map: {
        border: 0,
        borderRadius: 16,
        width: '100%',
    },
    iconButton: {
        display: 'inline-flex',
        verticalAlign: 'middle',
        marginRight: theme.spacing(1),
        color: theme.palette.secondary.light,
    }
}));

export default function contact(): JSX.Element {
    const classes = useStyles();

    return (
        <>
            <Grid container spacing={4} className={classes.container}>
                <Grid item xs={12} sm={6} >
                    <Typography variant="h6" component="h2" color="inherit" gutterBottom className={classes.gridTitle}>
                        WhatsApp
                    </Typography>
                    <ul className={classes.list}>
                        <li className={classes.listItem}><Link href="https://api.whatsapp.com/send?phone=+6282166284011&text=Salam%20Sehat%20kepada%20Bapak/Ibu%20dari%20PT%20Tri%20Mustika%20Sejagat" variant="subtitle1" className={classes.link}><span className={classes.iconButton} aria-hidden="true"><WAIcon /></span>+62 821 6628 4011 </Link></li>
                    </ul>
                </Grid>
                <Grid item xs={12} sm={6} >
                    <Typography variant="h6" component="h2" color="inherit" gutterBottom className={classes.gridTitle}>
                        Telepon
                    </Typography>
                    <ul className={classes.list}>
                        <li className={classes.listItem}><Link href="tel:+6282166284011" variant="subtitle1" className={classes.link}><span className={classes.iconButton} aria-hidden="true"><CallIcon /></span>+62 821 6628 4011</Link></li>
                    </ul>
                </Grid>
                <Grid item xs={12} sm={6} >
                    <Typography variant="h6" component="h2" color="inherit" gutterBottom className={classes.gridTitle}>
                        Media Sosial
                    </Typography>
                    <ul className={classes.list}>
                        <li className={classes.listItem}><Link href="https://www.facebook.com/trimustika.sejagat.3" variant="subtitle1" className={classes.link}><span className={classes.iconButton} aria-hidden="true"><FBIcon /></span>Tri Mustika Sejagat</Link></li>
                        <li className={classes.listItem}><Link href="https://www.instagram.com/pt.trimustikasejagat/" variant="subtitle1" className={classes.link}><span className={classes.iconButton} aria-hidden="true"><IGIcon /></span>@pt.trimustikasejagat</Link></li>
                        <li className={classes.listItem}><Link href="mailto:trimustikasejagat.id@gmail.com" variant="subtitle1" className={classes.link}><span className={classes.iconButton} aria-hidden="true"><EmailIcon /></span>trimustikasejagat.id@gmail.com</Link></li>
                    </ul>
                </Grid>
                <Grid item xs={12} sm={6} >
                    <Typography variant="h6" component="h2" color="inherit" gutterBottom className={classes.gridTitle}>
                        Alamat
                    </Typography>
                    <Typography className={classes.address}>
                        Jl. Tengku Amir Hamzah No.168 A, Jati Karya, Kec. Binjai Utara, Kota Binjai, Sumatera Utara 20351
                    </Typography>
                    <iframe className={classes.map} title="Peta lokasi PT Tri Mustika Sejagat di Binjai" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.7503150493144!2d98.5082238144465!3d3.644327250925955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x303129f59100d34b%3A0x977055bf39336f8e!2sPT.%20Tri%20Mustika%20Sejagat%20-%20Produsen%20Rangka%20Atap%20Baja%20Ringan%20(Kanal%20%26%20Reng)%2C%20Seng%20(BJLS%2C%20Spandek%2C%20Genteng)%20%7C%20Distributor%20Besi%20(Hollow%2C%20Beton%2C%20Siku%2C%20dll)%20dan%20Bahan%20Bangunan!5e0!3m2!1sid!2sid!4v1619681202696!5m2!1sid!2sid" width="300" height="150" allowFullScreen={false} loading="lazy"></iframe>
                </Grid>
            </Grid>
        </>
    );
}
